module.exports = __webpack_public_path__ + "media/images/ellipsis-50px-84f994a3855085e483850f9382cdace6.gif";